// Core
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Style
import './styles.scss';

import Slider from "react-slick";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VolumeUp from '@mui/icons-material/VolumeUp';
import VolumeOff from '@mui/icons-material/VolumeOff';
import Slide from '@mui/material/Slide';
import ReactPlayer from 'react-player';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SliderBanner = (props) => {
    const { title, imageArray, isVideo } = props;
    const [nav1, setNav1] = useState(null)
    const [nav2, setNav2] = useState(null)
    const [isMuted, setIsMuted] = useState(true);

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    useEffect(() => {
        setIsVideoLoaded(false);
    }, [isVideo]);

    const openLightbox = (index) => {
        setSelectedImageIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };

    const lightboxSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: selectedImageIndex,
        adaptiveHeight: true
    };

    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: true

    };

    if (isVideo && isVideo.length > 0) {
        const videoSrc = Array.isArray(isVideo) ? isVideo[0]?.video : isVideo;
        return (
            <div className='__slider_banner_sec' style={{ position: 'relative' }}>
                {!isVideoLoaded && imageArray?.[0] && (
                    <img
                        src={imageArray[0]}
                        alt="Video Thumbnail"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '600px',
                            objectFit: 'cover',
                            zIndex: 2,
                        }}
                    />
                )}
                <ReactPlayer
                    url={videoSrc}
                    playing={true}
                    loop={true}
                    muted={isMuted}
                    volume={isMuted ? 0 : 1}
                    width='100%'
                    height='600px'
                    className='imageLoader'
                    playsinline={true}
                    onStart={() => setIsVideoLoaded(true)}
                />
                {isVideoLoaded &&
                    <IconButton
                        className='mute-button'
                        onClick={() => setIsMuted(prev => !prev)}
                    >
                        {isMuted ? <VolumeOff /> : <VolumeUp />}
                    </IconButton>}
            </div >
        )
    }

    return (
        <div className='__slider_banner_sec'>

            <Slider
                asNavFor={nav2}
                ref={slider => (setNav1(slider))}
                {...settings}
            >

                {imageArray.map((item, idx) => {
                    return (
                        <img src={item} alt={idx} key={idx} className='imageLoader' />
                    )
                })}

            </Slider>
            <div className='__img_thumb_set'>
                <Slider
                    asNavFor={nav1}
                    ref={slider => (setNav2(slider))}
                    slidesToShow={imageArray.length}
                    swipeToSlide={false}
                    focusOnSelect={true}
                    autoplay={true}
                >
                    {imageArray.map((item, idx) => {
                        return (
                            <img
                                src={item}
                                key={idx}
                                alt={idx}
                                onClick={() => openLightbox(idx)}
                                style={{ cursor: 'pointer' }}
                            />
                        )
                    })}
                </Slider>
            </div>
            <Dialog
                fullScreen
                open={lightboxOpen}
                onClose={closeLightbox}
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                        boxShadow: 'none',
                    },
                }}
            >
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={closeLightbox}
                    aria-label="close"
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: 9999, color: 'white' }}
                >
                    <CloseIcon fontSize="large" />
                </IconButton>

                <div style={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    padding: '0 40px'
                }}>
                    <Slider {...lightboxSettings}>
                        {imageArray.map((item, idx) => (
                            <div key={idx} style={{ outline: 'none' }}>
                                <img
                                    src={item}
                                    alt={`Full view ${idx}`}
                                    style={{
                                        width: '100%',
                                        height: '90vh',
                                        objectFit: 'contain',
                                        margin: '0 auto'
                                    }}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </Dialog>

        </div>
    );
};

export default SliderBanner;

SliderBanner.propTypes = {
    title: PropTypes.string,
    imageArray: PropTypes.any,
};